const AngularServiceProvider = {
  get: angularServiceName => {
    return angular.element(document.body).injector().get(angularServiceName);
  },
};

export default AngularServiceProvider;
